import { CurrencyId } from "@/services/currencies/currenciesTypes";
import { z } from "zod";

export const CurrencyId_Schema = z.enum(CurrencyId);

export const Currency_Schema = z.object({
  id: CurrencyId_Schema,
  code: z.string(),
  /** Name without the symbol, e.g. "Koruna česká". Not translated — the API returns a single name per currency. */
  name: z.string(),
  symbol: z.string(),
  isPositionLeft: z.boolean(),
  isSpaceSeparator: z.boolean(),
  decimalPrecisionWhenCurrencySwitch: z.number().int().nonnegative(),
  decimalSeparator: z.string(),
  thousandsSeparator: z.string(),
  isAvailableForSwitchSelector: z.boolean(),
  /** Rate to every other currency, multiplied by a thousand, keyed by the target currency id. */
  ratioThousands: z.record(z.string(), z.number()),
});
